import classNames from "classnames";

import { ChatStatus } from "@/shared/domain/chat";

import styles from "./SessionStatusBadge.module.css";

interface SessionStatusBadgeProps {
  status: ChatStatus;
}

const STATUS_DISPLAY: Record<ChatStatus, { label: string; className: string }> =
  {
    [ChatStatus.NOT_STARTED]: {
      label: "Not started",
      className: styles.notStarted,
    },
    [ChatStatus.USER_TURN]: { label: "User turn", className: styles.userTurn },
    [ChatStatus.ROBOTO_TURN]: {
      label: "Working",
      className: styles.robotoTurn,
    },
    [ChatStatus.CLIENT_TOOL_TURN]: {
      label: "Client tools",
      className: styles.clientToolTurn,
    },
    [ChatStatus.GOALS_FAILED]: {
      label: "Goals failed",
      className: styles.goalsFailed,
    },
  };

export function SessionStatusBadge({ status }: SessionStatusBadgeProps) {
  const display = STATUS_DISPLAY[status];
  return (
    <span className={classNames(styles.badge, display.className)}>
      {display.label}
    </span>
  );
}
